import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "app-page"
};
import { remove } from '@/api/system/menu';
import { MENU_STYLE } from '@/constant/system/code';
import { deleteBox, toast } from '@/utils/message';
import { renderActionDialog } from './action';
import { renderAddForm } from './add';
import { renderEditForm } from './edit';
import { createTable } from './table';

import { ref, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Menu',
  setup(__props) {
    const tableRef = ref();
    const addRef = ref();
    const editRef = ref();
    const menuActionRef = ref();
    let table = null;
    let addForm = null;
    let editForm = null;
    let menuAction = null;
    onMounted(() => {
      table = createTable(tableRef.value, {
        rowAdd,
        rowDelete,
        rowEdit,
        rowHandle
      }, {
        addFn,
        searchFn
      });
      addForm = renderAddForm(addRef.value);
      editForm = renderEditForm(editRef.value);
      menuAction = renderActionDialog(menuActionRef.value);
      editForm.onSaveSuccess = () => {
        table?.load();
      };
      addForm.onSaveSuccess = () => {
        table?.load();
      };
      addForm.onOpend = () => {
        addForm?.hideFormItemByKey('component');
      };
      table.load();
    });
    // 行操作
    function rowHandle(row) {
      menuAction?.open({
        menuId: row.id
      });
    }
    function rowAdd(row) {
      addForm?.open({
        parentId: row.id,
        sort: 0
      });
    }
    function rowEdit(row) {
      editForm?.open(row.id).then(() => {
        if (row.menuStyle === MENU_STYLE.CATALOG) {
          editForm?.hideFormItemByKey('component');
        } else {
          editForm?.showFormItemByKey('component');
        }
      });
    }
    function rowDelete(row) {
      deleteBox().then(() => {
        remove([row.id]).then(() => {
          toast.success('删除成功');
          table?.load();
        });
      });
    }
    function addFn() {
      addForm?.open({
        sort: 0,
        menuStyle: MENU_STYLE.CATALOG
      });
    }
    function searchFn() {
      table?.load();
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "table",
        style: {
          "height": "100%"
        },
        ref_key: "tableRef",
        ref: tableRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "addRef",
        ref: addRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "editRef",
        ref: editRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "menuActionRef",
        ref: menuActionRef
      }, null, 512)]);
    };
  }
});